<script setup lang="ts">
import AboutNama from "@/components/settings/AboutNama.vue";
</script>

<template>
  <div class="tw-h-full ">
    <section
      class="tw-rounded-lg tw-border tw-border-gray-200 tw-bg-namaBackground-deep-light tw-p-4
             dark:tw-border-gray-700 dark:tw-bg-namaBackground-deep-dark">
    <AboutNama/>
    </section>
  </div>
</template>

<style scoped>

</style>
